import React, { FC } from 'react';
import SignInForm from '@modules/auth/components/form/SignInForm';
import { useSendTask } from '@core/http/hooks';

import * as AuthService from './service';
import { AuthenticateParams } from '@modules/auth/model';
import { pipe } from 'fp-ts/function';
import * as TE from 'fp-ts/TaskEither';
import { useAuthContext } from '@modules/auth/context';
import { replaceRouteBy } from '@shared/utils/routes';
import Seo from '@shared/components/seo/Seo';
import { useTranslations } from '@shared/modules/translation/hooks';
import AuthLayout from '@shared/components/layout/auth/AuthLayout';

interface SignInProps {
  referrer?: string;
}

const SignIn: FC<SignInProps> = ({ referrer }) => {
  const translations = useTranslations();

  const { updateProfile } = useAuthContext();

  const [loading, authenticate, error] = useSendTask(AuthService.authenticate);

  const handleSubmit = (params: AuthenticateParams) => {
    pipe(
      () => authenticate(params),
      TE.chainFirstIOK(profile => () => {
        updateProfile(profile);

        if (referrer) {
          window.location.replace(referrer);
        } else {
          replaceRouteBy('home');
        }
      }),
    )();
  };

  return (
    <AuthLayout>
      <Seo title={translations.signIn.title} />

      <SignInForm loading={loading} error={error} onSubmit={handleSubmit} />
    </AuthLayout>
  );
};

export default SignIn;
